<template>
  <go-for-good
    :catalog-text="catalogText"
    :commission-percentage="commissionPercentage"
    :raised-amount="raisedAmount"
    :institutions-number="institutionsNumber"
    :asset="asset"
    :institutions="institutions"
  />
</template>

<script>
import GoForGood from '~/components/goforgood/GoForGood'
export default {
  components: { GoForGood },
  async asyncData({ $axios, store, error, $sentry }) {
    try {
      const params = {
        ...store.getters.storeInfo,
      }
      const {
        catalog_text: catalogText,
        commission_percentage: commissionPercentage,
        raised_amount: raisedAmount,
        institutions_number: institutionsNumber,
        asset,
        institutions,
      } = await $axios.$get('/go_for_good', {
        params,
      })

      return {
        catalogText,
        commissionPercentage,
        raisedAmount,
        institutionsNumber,
        asset,
        institutions,
      }
    } catch (err) {
      error({
        statusCode: 404,
        message: 'Page not found',
      })
    }
  },
  head() {
    return {
      title: 'Go For Good',
      description:
        this.catalogText || this.$t('go_for_good.collection.description'),
    }
  },
}
</script>

<style></style>
